export type WorkspaceMemberRole = 'owner' | 'member' | 'viewer';

export type WorkspaceMemberRow = {
  id: string;
  userId: string;
  email: string;
  name: string;
  role: WorkspaceMemberRole;
  createdAt: string;
};

function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : {};
}

function text(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function normalizeWorkspaceMemberRole(value: unknown): WorkspaceMemberRole {
  const raw = text(value).toLowerCase().replace(/^workspace_/, '');
  if (raw === 'owner' || raw === 'admin') return 'owner';
  if (raw === 'viewer' || raw === 'guest') return 'viewer';
  return 'member';
}

/** MEMBER-PANEL-ID-1. The list payload uses userId, fullName, and workspaceRole. */
export function mapWorkspaceMemberRow(input: unknown): WorkspaceMemberRow {
  const row = asRecord(input);
  const user = asRecord(row.user);
  const userId = text(row.userId) || text(row.user_id) || text(user.id);
  const email = text(row.email) || text(user.email);
  const joined = [text(user.firstName), text(user.lastName)].filter(Boolean).join(' ');
  const name = text(row.fullName) || text(row.name) || joined || email;
  return {
    id: text(row.id) || userId,
    userId,
    email,
    name,
    role: normalizeWorkspaceMemberRole(row.workspaceRole ?? row.role),
    createdAt: text(row.joinedAt) || text(row.createdAt) || text(row.created_at),
  };
}

export function workspaceRoleWire(role: WorkspaceMemberRole): string {
  return `workspace_${role}`;
}
